import axios from "axios";
import { IMatch, IMatchStats, ICreateMatchPayload } from "../interfaces/match";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3000";

// Get all matches for a specific tracker
export const getTrackerMatches = async (trackerId: string, params?: {
    status?: string;
    sortBy?: 'matchedAt' | 'icpRating' | 'matchScore';
    order?: 'asc' | 'desc';
}) => {
    const token = localStorage.getItem("token");
    const searchParams = new URLSearchParams();

    if (params?.status) searchParams.append("status", params.status);
    if (params?.sortBy) searchParams.append("sortBy", params.sortBy);
    if (params?.order) searchParams.append("order", params.order);

    const url = `${API_BASE}/matches/tracker/${trackerId}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;

    const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Get all my matches (across all trackers)
export const getMatches = async (params?: {
    project?: string;
    status?: string;
}) => {
    const token = localStorage.getItem("token");
    const searchParams = new URLSearchParams();

    if (params?.project) searchParams.append("project", params.project);
    if (params?.status) searchParams.append("status", params.status);

    const url = `${API_BASE}/matches${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;

    const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Get a specific match
export const getMatch = async (id: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_BASE}/matches/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Update a match (e.g., add ICP rating, notes)
export const updateMatch = async (id: string, updates: Partial<IMatch>) => {
    const token = localStorage.getItem("token");
    const response = await axios.put(`${API_BASE}/matches/${id}`, updates, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Delete a match
export const deleteMatch = async (id: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.delete(`${API_BASE}/matches/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Convert a match to a prospect and add to kanban
export const convertMatchToProspect = async (id: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API_BASE}/matches/${id}/convert-to-prospect`, {}, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Batch dismiss matches
export const batchDismissMatches = async (matchIds: string[]) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API_BASE}/matches/batch/dismiss`, { matchIds }, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Get match statistics for a tracker
export const getTrackerMatchStats = async (trackerId: string): Promise<IMatchStats> => {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_BASE}/matches/tracker/${trackerId}/stats`, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

// Admin: Create a match for a user (hidden endpoint)
export const adminCreateMatch = async (payload: ICreateMatchPayload) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API_BASE}/matches/admin/create`, payload, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};
